/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three'
import { useLoader } from '@react-three/fiber'
import img from './g_text.png'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/guitar.glb')
  const texture = useLoader(THREE.TextureLoader, img)

  return (
    <group ref={group} {...props} dispose={null} rotation={[0, Math.PI*1.5, Math.PI / 2]}>
      <mesh geometry={nodes.Cube.geometry}  >
      <meshBasicMaterial attach="material" map={texture} />
      </mesh>
    </group>
  )
}

useGLTF.preload('/guitar.glb')
